import React from 'react';
import Image from 'next/image';
import styles from './styles';

const PostPageQuestion = () => {
  return (
    <>
      <div className="question">
        <h1>Did this fix your issue?</h1>
        <div className="smiles">
          <div className="glad-smile">
            <Image
              draggable={false}
              src="/icons/glad-smile.png"
              alt="icon-search"
              width={30}
              height={30}
              loading="lazy"
            />
          </div>
          <div className="sad-smile">
            <Image
              draggable={false}
              src="/icons/sad-smile.png"
              alt="icon-search"
              width={30}
              height={30}
              loading="lazy"
            />
          </div>
        </div>
        <span>
          Our team is just an e-mail away and ready to answer your question!
        </span>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default PostPageQuestion;
